import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import type { RohsBriefingStep } from '../../utils/rohsLegislationBriefing'
import { V2RohsLegislationBriefingStepShell } from './V2RohsLegislationBriefingStepShell'

export function V2RohsProductDescriptionStep({
  step,
  index,
  description,
  hasProductDescription,
  canWrite,
  onEditDescription,
}: {
  step: RohsBriefingStep
  index: number
  description: string | null | undefined
  hasProductDescription: boolean
  canWrite: boolean
  onEditDescription: () => void
}) {
  const { t } = useTranslation('common')

  let descriptionText = t(
    'v2.pages.products.detail.rohsBriefing.productDescription.noDescription'
  )
  if (hasProductDescription && description != null) {
    descriptionText = description
  }

  return (
    <V2RohsLegislationBriefingStepShell
      step={step}
      index={index}
      actions={
        canWrite ? (
          <Button
            type='button'
            size='sm'
            variant='outline'
            onClick={onEditDescription}
          >
            {t(
              'v2.pages.products.detail.rohsBriefing.productDescription.action'
            )}
          </Button>
        ) : undefined
      }
    >
      <p className='whitespace-pre-wrap text-sm text-muted-foreground'>
        {descriptionText}
      </p>
    </V2RohsLegislationBriefingStepShell>
  )
}
